<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <!-- Tlačítko pro otevření/zavření navigačního šuplíku na malých displejích -->
      <v-app-bar-nav-icon @click="drawer = !drawer" v-if="display.mdAndDown"></v-app-bar-nav-icon>
      <v-spacer v-if="display.smAndDown"></v-spacer>

      <!-- Logo aplikace -->
      <router-link to="/" class="d-flex align-center"
                   style="background-color:#FFFF; padding: 3px; margin-left: 5px; border-radius: 5px;"
                   v-if="display.mdAndUp">
        <img :src="imageUrl" alt="Logo ROBISU" width="140">
      </router-link>

      <v-spacer v-if="display.smAndUp"></v-spacer>

      <!-- Hlavní navigační odkazy se skryjí na malých displejích -->
      <div v-if="display.lgAndUp">
        <v-btn text to="/">{{ $t('nav.calendar') }}</v-btn>
        <v-btn text to="/vysledky/" :active="isResultsActive">
          {{ $t('nav.results') }}
          <sup v-if="liveResultsActive" class="live-sup">{{ $t('nav.live') }}</sup>
        </v-btn>
        <!-- Žebříčky -->
        <v-menu offset-y transition="slide-y-transition" v-if="display.lgAndUp">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props">
              {{ $t('nav.rankings') }}
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item link :to="`/ranking/national/${currentYear}/`">
              <v-list-item-title>{{ $t('nav.rankings_national') }}</v-list-item-title>
            </v-list-item>
            <v-list-item link :to="`/ranking/clubs/${currentYear}/`">
              <v-list-item-title>{{ $t('nav.rankings_clubs') }}</v-list-item-title>
            </v-list-item>
            <v-list-item :to="`/ranking/${selectedRegion}/${currentYear}/`">
              <v-list-item-title>{{ $t('nav.rankings_regional') }}</v-list-item-title>
            </v-list-item>
            <v-list-item link :to="`/ranking/world/${prevYear}/${prevdMonth}/M21/`">
              <v-list-item-title>{{ $t('nav.rankings_world') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn text to="/clenove" v-if="isLoggedIn">{{ $t('nav.members') }}</v-btn>
        <v-btn text to="/oddil">{{ $t('nav.clubs') }}</v-btn>
        <!-- <v-btn text to="/napoveda">{{ $t('nav.help') }}</v-btn> -->
      </div>

      <v-menu offset-y transition="slide-y-transition" v-if="display.lgAndUp">
        <template v-slot:activator="{ props }">
          <v-btn v-if="isLoggedIn" text v-bind="props">
            {{ $t('nav.representation') }}
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item link to="/oddil/REP">
            <v-list-item-title>{{ $t('nav.rep_adults') }}</v-list-item-title>
          </v-list-item>

          <v-list-item link to="/oddil/SCM">
            <v-list-item-title>{{ $t('nav.rep_scm') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y transition="slide-y-transition" v-if="display.lgAndUp">
        <template v-slot:activator="{ props }">
          <v-btn v-if="isLoggedIn" text v-bind="props" :aria-label="$t('nav.more')">
            <v-icon v-if="display.lgAndUp && !display.xlAndUp">mdi-dots-vertical</v-icon>
            <template v-else>
              {{ $t('nav.more') }}
              <v-icon right>mdi-chevron-down</v-icon>
            </template>
          </v-btn>
        </template>
        <v-list>
          <v-list-item link :to="'/dashboard'" v-if="isManager()">
            <v-list-item-title>{{ $t('nav.panel') }}</v-list-item-title>
          </v-list-item>

          <v-list-item link :to="'/radio'" v-if="isRadioControlManager()">
            <v-list-item-title>{{ $t('nav.radio') }}</v-list-item-title>
          </v-list-item>

          <v-list-item link :to="'/ochecklist'" v-if="isManager()">
            <v-list-item-title>O-checklist</v-list-item-title>
          </v-list-item>


          <v-list-item v-if="isLoggedIn" link to="/napoveda">
            <v-list-item-title>{{ $t('nav.help') }}</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="isLoggedIn" link to="/export">
            <v-list-item-title>{{ $t('nav.exports') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>

      <LocalsSwitcher v-if="display.mdAndUp" />

      <!-- Menu přihlášeného uživatele -->
      <v-menu transition="slide-y-transition" v-if="isLoggedIn">
        <template v-slot:activator="{ props }">
          <v-btn text v-bind="props">
            {{ firstName }} {{ last_name }} <span v-if="clubIndex && clubIndex !== 'null' && clubIndex !== ''">&nbsp;({{
             clubIndex
            }})</span><span v-else>&nbsp;({{ $t('nav.unreg') }})</span>
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="`/ucet/${userID}`">{{ $t('nav.my_profile') }}</v-list-item>
          <v-list-item v-if="isLoggedIn && clubIndex && clubIndex !== 'null' && clubIndex !== ''"
                       :to="`/oddil/${clubIndex.slice(0, 3)}`">
            <v-list-item-title>{{ $t('nav.my_club') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/finance">
            <v-list-item-title>{{ $t('nav.my_finance') }}</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/nastaveni">
            <v-list-item-title>{{ $t('nav.settings') }}</v-list-item-title>
          </v-list-item>
          <v-divider :thickness="2" class="border-opacity-25"></v-divider>
          <v-list-item @click="logout">
            <v-list-item-title>{{ $t('nav.logout') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- Tlačítko pro přihlášení, pokud uživatel není přihlášený -->
      <v-btn dark to="/login" v-else>{{ $t('nav.login') }}</v-btn>


    </v-app-bar>

    <!-- Navigační šuplík pro malé displeje -->
    <v-navigation-drawer v-model="drawer" app fixed temporary>
      <v-list>
        <v-img :src="drawerLogoUrl" alt="Logo ROBISU" width="170" style="margin: 0px auto"></v-img>
        <v-list-item link :to="'/'">
          <v-icon>mdi-calendar-text</v-icon>
          <v-list-item-title>{{ $t('nav.calendar') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/vysledky/'" :active="isResultsActive">
          <v-icon>mdi-trophy</v-icon>
          <v-list-item-title>
            {{ $t('nav.results') }}
            <sup v-if="liveResultsActive" class="live-sup">{{ $t('nav.live') }}</sup>
          </v-list-item-title>
        </v-list-item>
        <v-list-item link :to="`/ranking/national/${currentYear}/`">
          <v-icon>mdi-podium</v-icon>
          <v-list-item-title>{{ $t('nav.rankings_national_long') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="`/ranking/clubs/${currentYear}/`">
          <v-icon>mdi-shield-home</v-icon>
          <v-list-item-title>{{ $t('nav.rankings_clubs_long') }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="`/ranking/${selectedRegion}/${currentYear}/`">
          <v-icon>mdi-podium-gold</v-icon>
          <v-list-item-title>{{ $t('nav.rankings_regional_long') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="`/ranking/world/${prevYear}/${prevdMonth}/M21/`">
          <v-icon>mdi-crown</v-icon>
          <v-list-item-title>{{ $t('nav.rankings_world_long') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/clenove'" v-if="isLoggedIn">
          <v-icon>mdi-account-group</v-icon>
          <v-list-item-title>{{ $t('nav.members') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/oddil'">
          <v-icon>mdi-home-account</v-icon>
          <v-list-item-title>{{ $t('nav.clubs') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/oddil/REP">
          <v-icon>mdi-run-fast</v-icon>
          <v-list-item-title>{{ $t('nav.rep') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/oddil/SCM">
          <v-icon>mdi-face-man-shimmer</v-icon>
          <v-list-item-title>{{ $t('nav.scm') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/dashboard'" v-if="isManager()">
          <v-icon>mdi-cog</v-icon>
          <v-list-item-title>{{ $t('nav.panel') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/radio'" v-if="isRadioControlManager()">
          <v-icon>mdi-radio-tower</v-icon>
          <v-list-item-title>{{ $t('nav.radio') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/ochecklist'" v-if="isManager()">
          <v-icon>mdi-text-box-check-outline</v-icon>
          <v-list-item-title>O-checklist</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/export'" v-if="isLoggedIn">
          <v-icon>mdi-export</v-icon>
          <v-list-item-title>{{ $t('nav.exports') }}</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="'/napoveda'">
          <v-icon>mdi-help-circle</v-icon>
          <v-list-item-title>{{ $t('nav.help') }}</v-list-item-title>
        </v-list-item>
        <v-list-item>
          <LocalsSwitcher v-if="display.smAndDown" />
        </v-list-item>

        <!-- Další odkazy pro navigační šuplík -->
      </v-list>
    </v-navigation-drawer>

    <SnackbarQueue />

    <!-- Hlavní obsah aplikace -->
    <v-main>
      <router-view/>
    </v-main>


    <v-footer class="app-footer">
      <v-row>
        <v-col class="text-center">
          <span style="font-weight: bold;">ROB</span>ácký <span style="font-weight: bold;">I</span>nformační <span
            style="font-weight: bold;">S</span>ystém - ROBIS, verze
          <router-link to="/verze">{{ latestVersion }}</router-link>,
          &copy;ROBis tým, info@rob-is.cz
        </v-col>
      </v-row>
    </v-footer>

  </v-app>
</template>

<script setup>
import {storeToRefs} from 'pinia';
import {useAuthStore} from '/auth.js';
import {ref, computed} from 'vue';
import {useRoute} from 'vue-router';
import {useDisplay, useTheme} from 'vuetify';
import {latestVersion} from '@/composables/version.js';
import SnackbarQueue from "@/components/shared/SnackbarQueue.vue";
import {useSnackbarStore} from "@/stores/snackbarStore";
import LocalsSwitcher from "@/components/shared/LocalsSwitcher.vue";

const authStore = useAuthStore();
const {isLoggedIn, isManager, isRadioControlManager, userID, firstName, last_name, clubIndex, liveResultsActive} = storeToRefs(authStore);
const display = ref(useDisplay());
const theme = useTheme();
const route = useRoute();
const drawer = ref(false);
const currentYear = new Date().getFullYear();
const selectedRegion = computed(() =>
  clubIndex.value ? clubIndex.value.slice(0, 1).toUpperCase() : 'A' // výchozí region
)

const now = new Date()
const prev = new Date(now.getFullYear(), now.getMonth(), 1)
prev.setMonth(prev.getMonth() - 1)

const prevYear = prev.getFullYear()
const prevdMonth = prev.getMonth() + 1 // 1..12


// const hasREP = computed(() => 
//   rolesByIndex.value.some(r => r.index.startsWith('RCZ'))
// )
// const hasSCM = computed(() => 
//   rolesByIndex.value.some(r => r.index.startsWith('SCM'))
//)

const logout = () => {
  authStore.logout();
};

const snackbar = useSnackbarStore() //Snackbar pro zobrazení úspěchu

const staticBase = process.env.VUE_APP_API_STATIC_URL + 'static/'
const imageUrl = ref(staticBase + 'logo_new.png');
// Drawer na malých displejích: v tmavém režimu světlé logo na tmavém pozadí
const drawerLogoUrl = computed(() =>
  theme.global.current.value.dark
    ? staticBase + 'logo_new_dark.png'
    : staticBase + 'logo_new.png'
);

// /vysledky/:year/:raceId jsou sibling routes, ne children → router isActive nestačí
const isResultsActive = computed(() =>
  route.path === '/vysledky' || route.path.startsWith('/vysledky/')
);


</script>


<style scoped>
/* Vuetify default: flex 1 1 auto — prevents footer bg stretching on short pages */
.app-footer {
  flex-grow: 0;
}

a:hover {
  color: inherit;
}

/* Skrýt na malých displejích */
.hidden-sm-and-down {
  display: none;
}

@media (min-width: 960px) {
  /* MD breakpoint od Vuetify */
  .hidden-sm-and-down {
    display: block;
  }
}

.live-sup {
  display: inline-block;
  margin-left: 2px;
  color: #ff3b30;
  font-weight: 800;
  font-size: 0.7em;
  line-height: 1;
  letter-spacing: 0.02em;
}
</style>


